const autoNgTemplateLoaderTemplate1 = require('./registryAccess.html');

angular.module('portainer.docker').component('dockerRegistryAccessView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'DockerRegistryAccessController',
  bindings: {
    endpoint: '<',
  },
});
